var map = {
	"./arrow-step-1.png": 55696,
	"./arrow-step-1.svg": 84245,
	"./arrow-step-2.svg": 45164,
	"./arrow-step-3.svg": 5008,
	"./circle-sketch.svg": 42067,
	"./data-collection-img.webp": 29337,
	"./empower-item-1.webp": 13550,
	"./empower-item-2.webp": 9989,
	"./empower-item-3.webp": 63658,
	"./empower-item-4.webp": 72425,
	"./header-image.webp": 46942,
	"./identification-opportunities.webp": 65585,
	"./implementation.webp": 31154,
	"./market-segmentation.webp": 57107,
	"./subline-red-sketch.svg": 37649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71317;